module.exports = __webpack_public_path__ + "static/media/ico_report_o.8d9fcc77.svg";